import { ButtonItem as AKButtonItem, type ButtonItemProps } from '@atlaskit/menu';
import { token } from '@atlaskit/tokens';
import React, { forwardRef, type RefAttributes } from 'react';

type FixedButtonItemProps = ButtonItemProps & {
  onMouseEnter?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  onMouseLeave?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  style?: React.CSSProperties;
};

const AKButtonItemWithStyle = AKButtonItem as React.ForwardRefExoticComponent<
  FixedButtonItemProps & RefAttributes<HTMLElement>
>;

const ButtonItem = forwardRef<HTMLElement, FixedButtonItemProps>(function ButtonItem(
  { children, style, ...props },
  ref
) {
  return (
    <AKButtonItemWithStyle
      {...props}
      style={{ ...style, paddingInline: token('space.200') }}
      ref={ref}
    >
      {children}
    </AKButtonItemWithStyle>
  );
});

export default ButtonItem;
